// extracted by mini-css-extract-plugin
export default {"details":"_3p09qRgSfze2DLgjNQoK5h","details__info-panel":"_3HM2BW9uX9ulOofgZ2y8vK","details__spec-container":"_2ZWrxDbwgF5bWOqJKiDbcj"};